<p-iconfield>

    <div class="input-container">

        <i aria-hidden="true" class="fas fa-calendar-alt"></i>

        <input pInputText
               [(ngModel)]="selectedFixedRangeLabel"
               (click)="op.toggle($event)"
               class="cursor-pointer"
               placeholder=""
               readonly="readonly"
               size="large"/>
    </div>

</p-iconfield>

<p-popover #op>

    <div class="p-4 w-144">

        <div class="card flex">

            <div class="w-2/5">

                <h6 class="!mb-4 !mt-1 !text-sm">Common periods</h6>

                <a class="cursor-pointer inline-block" (click)="selectFixedRange('lastDays7')">Last 7 days</a><br/>
                <a class="cursor-pointer inline-block" (click)="selectFixedRange('lastDays14')">Last 14 days</a><br/>
                <a class="cursor-pointer inline-block" (click)="selectFixedRange('lastDays28')">Last 28 days</a><br/>
                <a class="cursor-pointer inline-block mb-3" (click)="selectFixedRange('lastYear')">Last year</a><br/>

                <a class="cursor-pointer inline-block" (click)="selectFixedRange('weekSoFar')">This week so far</a><br/>
                <a class="cursor-pointer inline-block" (click)="selectFixedRange('monthSoFar')">This month so far</a><br/>
                <a class="cursor-pointer inline-block mb-3" (click)="selectFixedRange('yearSoFar')">This year so far</a><br/>

                <a class="cursor-pointer inline-block" (click)="selectFixedRange('previousWeek')">Previous week</a><br/>
                <a class="cursor-pointer inline-block" (click)="selectFixedRange('previousMonth')">Previous month</a><br/>
                <a class="cursor-pointer inline-block mb-0" (click)="selectFixedRange('previousYear')">Previous year</a><br/>
            </div>

            <p-divider layout="vertical"/>

            <div class="w-3/5">

                <p-datepicker
                        class="max-w-full"
                        selectionMode="range"
                        (onSelect)="onDateChange()"
                        [(ngModel)]="selectedRangeDates"
                        [inline]="true"
                        [panelStyleClass]="'!relative'"></p-datepicker>
            </div>

        </div>
    </div>

</p-popover>
